module.exports = __webpack_public_path__ + "static/media/buisnessAnalytics.fc89b458.svg";